module.exports = __webpack_public_path__ + "static/img/cstSer_bg_white_02.964c32d2.svg";